// =============================================================================
// PAGES/ENQUADRAMENTO.TSX - Hub do motor de enquadramento (FILA DE TRABALHO)
// =============================================================================
// Reúne, em abas, as duas telas do enquadramento que antes viviam soltas:
//   • "Enquadramento Normativo" = Parâmetros Normativos (config do motor CAIXA) -
//     só ADMIN.
//   • "PMCMV" = Fila de Homologação PMCMV (motor propõe, humano homologa) -
//     qualquer usuário autenticado+ativo.
// As rotas originais (/admin/parametros-normativos e /homologacao-enquadramento)
// continuam existindo como deep-links; esta página só as agrupa na navegação.
// =============================================================================

import { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import type { ShellContext } from '../components/AppShell';
import AdminParametrosNormativos from './AdminParametrosNormativos';
import HomologacaoEnquadramento from './HomologacaoEnquadramento';

type Aba = 'normativo' | 'pmcmv';

export default function Enquadramento() {
  const { currentUser } = useOutletContext<ShellContext>();
  const isAdmin = currentUser?.papel === 'ADMIN';

  const [aba, setAba] = useState<Aba>(isAdmin ? 'normativo' : 'pmcmv');

  // Abas sem padding horizontal próprio: o texto da primeira aba fica alinhado
  // à esquerda do container (px-6), a mesma margem do conteúdo de cada página.
  const AbaBtn = ({ value, children }: { value: Aba; children: React.ReactNode }) => (
    <button
      type="button"
      onClick={() => setAba(value)}
      className={`py-3 text-sm font-medium border-b-2 -mb-px transition-colors ${
        aba === value
          ? 'border-otm-navy text-otm-navy'
          : 'border-transparent text-otm-txt-3 hover:text-otm-txt-1'
      }`}
    >
      {children}
    </button>
  );

  return (
    <div className="min-h-full flex flex-col bg-white">
      {/* Abas (sem título de página - alinhadas pela mesma margem do conteúdo) */}
      <div className="border-b border-otm-border px-6">
        <div className="flex gap-6">
          {isAdmin && <AbaBtn value="normativo">Enquadramento Normativo</AbaBtn>}
          <AbaBtn value="pmcmv">PMCMV</AbaBtn>
        </div>
      </div>

      {/* Conteúdo da aba (cada página traz seus próprios dados/estado) */}
      <div className="flex-1 min-h-0">
        {aba === 'normativo' && isAdmin && <AdminParametrosNormativos />}
        {aba === 'pmcmv' && <HomologacaoEnquadramento />}
      </div>
    </div>
  );
}
